import {Line} from "react-chartjs-2"
import {
    Chart as ChartJS,
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Tooltip,
} from "chart.js"
import React from "react"
import {getMerkmal} from "../../misc/widget-functions"

ChartJS.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Tooltip,
)

// Wird demmächst durch component lib ersetzt
const MinimalLineChart = ({widget, getDataFromPointer}) => {
    const {height} = widget
    const pointer = getMerkmal(widget)?.pointer
    const chartData = getDataFromPointer(pointer)

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {intersect: false, mode: "nearest"},
        elements: {
            line: {
                borderWidth: 3.5,
                borderCapStyle: "round",
                tension: 0.3,
            },
            point: {
                radius: (ctx) =>
                    ctx.dataIndex === 0 ||
                    ctx.dataIndex === ctx.dataset.data.length - 1
                        ? 5
                        : 0,
                borderWidth: 0,
            },
        },
        plugins: {
            legend: {display: false},
            tooltip: {
                backgroundColor: "#1f2937",
                titleColor: "#f9fafb",
                bodyColor: "#f9fafb",
                padding: 10,
                cornerRadius: 6,
                displayColors: true,
            },
        },
        scales: {
            x: {
                display: true,
                grid: {display: false},
            },
            y: {
                border: {display: false},
                grid: {
                    color: "#e9edf1",
                    lineWidth: 1,
                    drawTicks: false,
                },
                ticks: {
                    color: "#9aa4b1",
                    font: {size: 12},
                },
            },
        },
    }

    return (
        <div
            style={{
                width: "100%",
                height: height ?? "350px",
            }}>
            <Line
                data={chartData}
                options={options}
            />
        </div>
    )
}

export default MinimalLineChart
